<template>
  <tr class="p-0">
    <div v-if="props.cancelar">
      {{ props.motivo_cancelamento }}
    </div>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.casa_ht != null">
      <strong>[HTC]</strong>
      <strong>{{ props.casa_ht }}</strong>
    </td>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.fora_ht != null">
      <strong>[HTF]</strong>
      <strong>{{ props.fora_ht }}</strong>
    </td>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.casa_ht != null">
      <strong>[FTC]</strong>
      <strong>{{ props.casa_ft }}</strong>
    </td>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.fora_ht != null">
      <strong>[FTF]</strong>
      <strong>{{ props.fora_ft }}</strong>
    </td>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.casa_ht == null">
      <strong>[FTC]</strong>
      <strong>{{ props.casa_ft }}</strong>
    </td>

    <td v-if="!props.cancelar && props.vencedor_evento == null && props.fora_ht == null">
      <strong>[FTF]</strong>
      <strong>{{ props.fora_ft }}</strong>
    </td>
    <div v-if="!props.cancelar && props.vencedor_evento != null">
      {{ props.vencedor_evento }}
    </div>
  </tr>
</template>

<script>
export default {
  props: ['props']
};
</script>

<style lang="scss" scoped>
tr {
  background: transparent !important;
  border: transparent !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
